<!-- @format -->

@for (studyEvent of sortedEvents; track entityId($index, studyEvent)) {
  @if (sortedEvents.length > 1) {
    <span class="d-inline-block">
      {{ studyEvent.name | localizedString }}
    </span>
  }
  <app-study-event-info [studyEvent]="studyEvent" [teacherIds]="teacherIds"></app-study-event-info>
}
